import { render, staticRenderFns } from "./companyMsg.vue?vue&type=template&id=1ae4f0d5&scoped=true&"
import script from "./companyMsg.vue?vue&type=script&lang=js&"
export * from "./companyMsg.vue?vue&type=script&lang=js&"
import style0 from "@/styles/index.scss?vue&type=style&index=0&id=1ae4f0d5&prod&lang=scss&scoped=true&"
import style1 from "./companyMsg.vue?vue&type=style&index=1&id=1ae4f0d5&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae4f0d5",
  null
  
)

export default component.exports